import { agentInformation, modifyInfo, operatorList, operatorStatus, editOperator, addOperator } from '@/api/accountInfo'
const state = {
  customerInfo: {
    company_name: '', // 企业名称
    duty: '', // 统一社会信用码
    legal: '', // 法人姓名
    mobile: '', // 手机号
    email: '', // 法人邮箱
    tel: '', // 企业固话
    nature: '', // 企业性质
    brand: '', // 品牌名称
    licenseFileList: [],
    permitFileList: [],
    id1FileList: [],
    id2FileList: []
  },
  licensenoneBtnImg: false,
  permitnoneBtnImg: false,
  idnoneBtnImg1: false,
  idnoneBtnImg2: false,
  // 操作员
  tableData: [],
  queryControl: {
    keyword: ''
  },
  pageControl: {
    pageNumber: 1,
    pageSize: 10,
    total: 0
  }
}
const getters = {
  customerInfo: state => state.customerInfo,
  tableData: state => state.tableData,
  pageControl: state => state.pageControl,
  queryControl: state => state.queryControl,
  licensenoneBtnImg: state => state.licensenoneBtnImg,
  permitnoneBtnImg: state => state.permitnoneBtnImg,
  idnoneBtnImg1: state => state.idnoneBtnImg1,
  idnoneBtnImg2: state => state.idnoneBtnImg2
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 企业资料
  agentInformation({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await agentInformation(params)
      if (code === 200) {
        commit('save', {
          customerInfo: {
            ...state.customerInfo,
            ...data
          }
        })
        if (data.license) {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              licenseFileList: [{ name: data.license, url: data.license }]
            },
            licensenoneBtnImg: true
          })
        } else {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              licenseFileList: []
            },
            licensenoneBtnImg: false
          })
        }
        if (data.permit) {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              permitFileList: [{ name: data.permit, url: data.permit }]
            },
            permitnoneBtnImg: true
          })
        } else {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              permitFileList: []
            },
            permitnoneBtnImg: false
          })
        }
        if (data.idcard_pic.length === 1) {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              id1FileList: [{ name: data.idcard_pic[0], url: data.idcard_pic[0] }],
              id2FileList: []
            },
            idnoneBtnImg1: true,
            idnoneBtnImg2: false
          })
        } else if (data.idcard_pic.length === 2) {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              id1FileList: [{ name: data.idcard_pic[0], url: data.idcard_pic[0] }],
              id2FileList: [{ name: data.idcard_pic[1], url: data.idcard_pic[1] }]
            },
            idnoneBtnImg1: true,
            idnoneBtnImg2: true
          })
        } else {
          commit('save', {
            customerInfo: {
              ...state.customerInfo,
              id1FileList: [],
              id2FileList: []
            },
            idnoneBtnImg1: false,
            idnoneBtnImg2: false
          })
        }
        resolve()
      }
    })
  },
  // 修改企业资料
  modifyInfo({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await modifyInfo(params)
      res.code === 200 && resolve(res)
    })
  },
  // 操作员列表
  operatorListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await operatorList(params)
      if (code === 200) {
        commit('save', {
          tableData: data.data,
          pageControl: {
            ...state.pageControl,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 启/禁用管理员状态
  operatorStatusFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await operatorStatus(params)
      res.code === 200 && resolve(res)
    })
  },
  // 编辑管理员
  editOperatorFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await editOperator(params)
      res.code === 200 && resolve(res)
    })
  },
  // 添加管理员
  addOperatorFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await addOperator(params)
      res.code === 200 && resolve(res)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

